import { combineReducers } from 'redux';
import homeReducer from './homeReducer';
import categoryReducer from './categoryReducer';
import brandsReducer from './brandsReducer';
import brandLandingReducer from './brandLandingReducer';
import brandCategoryReducer from './brandCategoryReducer';
import productListingReducer from './productListingReducer';
import headerReducer from './headerReducer';
import menuReducer from './menuReducer';
import brandInstagramReducer from './brandInstagramReducer';
import productDetailsReducer from './productDetailsReducer';
import howTosReducer from './howTosReducer';
import trendsReducer from './trendsReducer';
import productsToCompareReducer from './productsToCompareReducer';
import searchDetailsReducer from './searchDetailsReducer';
import commonReducer from './commonReducer';
import footerReducer from './footerReducer';

export default combineReducers({
  homeReducer,
  categoryReducer,
  brandsReducer,
  brandLandingReducer,
  brandCategoryReducer,
  productListingReducer,
  headerReducer,
  menuReducer,
  brandInstagramReducer,
  productDetailsReducer,
  howTosReducer,
  trendsReducer,
  productsToCompareReducer,
  commonReducer,
  searchDetailsReducer,
  footerReducer
});
